// custom typefaces
import "@fontsource/montserrat/variable.css"
import "@fontsource/merriweather"
// normalize CSS across browsers
import "./src/normalize.css"
// custom CSS styles
import "./src/style.css"
import "./src/styles/index.scss"
import "./src/styles/heros.scss"
import "./src/styles/buttons.scss"
import "./src/styles/treasure-hunt/button-animations.scss"

// Highlighting for code blocks
import "prismjs/themes/prism.css"
import LogRocket from "logrocket"

export const onClientEntry = () => {
  LogRocket.init("y1lnhc/auxo-3d-test-site")
}
